import { NavLink } from "react-router-dom";
import { Home, Calculator, CalendarPlus, BarChart3, User, Gift } from "lucide-react";
import { useAuth } from "../context/AuthContext";

const ANON_ITEMS = [
  { to: "/", label: "Home", Icon: Home },
  { to: "/calculator", label: "Calc", Icon: Calculator },
  { to: "/laddoo", label: "Ladoo", Icon: BarChart3 },
  { to: "/poshan-panji", label: "Panji", Icon: CalendarPlus },
  { to: "/login", label: "Sign in", Icon: User },
];

const AUTH_ITEMS = [
  { to: "/dashboard", label: "Home", Icon: Home },
  { to: "/calculator", label: "Calc", Icon: Calculator },
  { to: "/daily-entry", label: "Daily", Icon: CalendarPlus },
  { to: "/referrals", label: "Refer", Icon: Gift },
  { to: "/profile", label: "Profile", Icon: User },
];

export default function BottomNav() {
  const { isAuthed } = useAuth();
  const items = isAuthed ? AUTH_ITEMS : ANON_ITEMS;
  return (
    <nav className="md:hidden fixed bottom-0 inset-x-0 z-30 bg-white/95 backdrop-blur border-t border-slate-200 shadow-[0_-4px_16px_-4px_rgba(0,0,0,0.06)]" data-testid="bottom-nav">
      <ul className="grid grid-cols-5">
        {items.map(({ to, label, Icon }) => (
          <li key={to}>
            <NavLink to={to} end
                     data-testid={`bnav-${label.toLowerCase().replace(/\s+/g, "-")}`}
                     className={({ isActive }) =>
                       `flex flex-col items-center justify-center gap-0.5 py-2 text-[10px] font-semibold ${isActive ? "text-emerald-700" : "text-slate-500 hover:text-slate-800"}`
                     }>
              <Icon size={20}/>
              <span>{label}</span>
            </NavLink>
          </li>
        ))}
      </ul>
      {/* iOS safe-area spacer */}
      <div style={{ height: "env(safe-area-inset-bottom, 0)" }}/>
    </nav>
  );
}
